import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IOrganization, IAudit } from '../../../interfaces/graph-types';
import { OrganizationService } from '../../../services/organization.service';
import { WatchOrganizationService } from '../../../services/watch-organization.service';
import { DatePipe } from '@angular/common';
import { UtilityService } from '../../../services/utility.service';

@Component({
  selector: 'organization-change-history',
  template: require('./organization-change-history.component.pug'),
  styles: [require('./organization-change-history.component.css').toString()],
})
export class OrganizationChangeHistoryComponent implements OnDestroy, OnInit {
  // -------------------------------------------------------------------
  constructor(
    private orgaService: OrganizationService,
    private orgaWatch: WatchOrganizationService,
    private utilityService: UtilityService,
    private datePipe: DatePipe,
  ) {
    this.scopeIcons = this.utilityService.auditScopeIcons();
  }

  scopeIcons: any = {};

  changes$: Observable<IAudit[]>;

  // -------------------------------------------------------------------
  ngOnInit() {
    this.changes$ = this.orgaService.audits(
      this.orgaWatch.organizationId().getValue(),
      48,
    );
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {}

  // -------------------------------------------------------------------
  diffDay(first, second) {
    return (
      this.datePipe.transform(first.createdAt) !=
      this.datePipe.transform(second.createdAt)
    );
  }
}
